import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import React from "react";
import img1 from "../../assets/img/supporticons/img1.png";
import img2 from "../../assets/img/supporticons/img2.png";
import img3 from "../../assets/img/supporticons/img3.png";
import img4 from "../../assets/img/supporticons/img4.png";
import OfficerCard from "../../common/officerCard";
import { Link } from "react-router-dom";
import { LangContext } from "../../context/LangContext";
const MainSupport = ({ support }) => {
  const lang = React.useContext(LangContext);
  const nep = lang.state.np;
  return (
    <>
      <div className="MainSupportContainer">
        <div className="wrapper">
          <div className="SUpportFlexContainer">
            <div className="SupportBox">
              <h4>{nep ? "Support" : "Support"}</h4>
              <div className="BoxContainer">
                <div className="Box">
                  <Link to="rates/interest-rates">
                    <img src={img1} alt="Image" />
                  </Link>

                  <h3>
                    <Link to="/rates/interest-rates">
                      {nep ? "दरहरू" : "Rates"}
                    </Link>
                  </h3>
                </div>
                <div className="Box">
                  <Link to="/contact-us">
                    <img src={img2} alt="Image" />
                  </Link>
                  <h3>
                    <Link to="/contact-us">
                      {nep ? "हाम्रो सम्पर्क" : "Contact Us"}
                    </Link>
                  </h3>
                </div>
                <div className="Box">
                  <Link to={`../emi-calculator`}>
                    <img src={img3} alt="Image" />
                  </Link>
                  <h3>
                    <Link to={`../emi-calculator`}>
                      {nep ? "ईएमआई क्याल्कुलेटर" : "EMI Calculator"}
                    </Link>
                  </h3>
                </div>
                <div className="Box">
                  <Link to={`../csr`}>
                    <img src={img4} alt="Image" />
                  </Link>
                  <h3>
                    <Link to={`../csr`}>{nep ? "सीएसआर" : "CSR"}</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="GrievenceOfficerBox">
              <div className="accordion" id="accordionExample">
                {support?.map((support, index) => {
                  return (
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded="true"
                          aria-controls={`collapse${index}`}
                        >
                          {nep
                            ? support.parent === "Information Officer"
                              ? "सूचना अधिकारी"
                              : support.parent === "Grievance Officer"
                              ? "गुनासो सुनुवाई अधिकारी"
                              : support.parent === "Compliance Officer"
                              ? "अनुपालन अधिकारी"
                              : support.parent
                            : support.parent}
                        </button>
                      </h2>
                      <div
                        key={index}
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${
                          index === 0 ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <OfficerCard
                            key={index}
                            officer={support.child}
                            nep={nep}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse`}
                      aria-expanded="true"
                      aria-controls={`collapse`}
                    >
                      {nep ? "साइबर अपराध तथा डिजिटल ठगी सम्पर्क अधिकृत" : "Cyber Crime and Digital Fraud Liaison Officer"}
                    </button>
                  </h2>
                  <div
                    id='collapse'
                    className='accordion-collapse collapse'
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body cyber-crime">
                      <div className="name">
                        <span>Name:</span> Santosh Kumar Chaurasia/ Sujan Dangol 
                      </div>
                      <div className="number">
                        <span>Phone Number:</span> 9747800843 / 9851255217 
                      </div>
                      <div className="email">
                        <span>Email:</span> complaince@gmail.com.np
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MainSupport;
